import * as React from 'react';
import { Image, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';

export type MicrosoftCloudItemProps = {
  name: string;
  icon: string;
  url: string;
  isSelected?: boolean;
};

export function MicrosoftCloudItem(props: MicrosoftCloudItemProps) {
  const classes = useStyles();

  return (
    <div
      role="button"
      onClick={() => {
        window.open(props.url, '_blank');
      }}
      className={props.isSelected ? mergeClasses(classes.root, classes.rootSelected) : classes.root}
    >
      <div className={classes.imageWrapper}>
        <Image src={props.icon}></Image>
      </div>
      <div className={classes.text}>{props.name}</div>
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    width: '92px',
    height: '88px',
    borderRadius: tokens.borderRadiusLarge,
    border: undefined,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    display: 'inline-flex',
    cursor: 'pointer',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.padding('8px', '4px'),
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    '&:hover:active': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  rootSelected: {
    ...shorthands.border('1px', 'solid', '#316BAA'),
  },
  imageWrapper: {
    width: '52px',
    height: '52px',
    borderRadius: tokens.borderRadiusLarge,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',
    '& > img': {
      width: '52px',
      height: '52px',
    },
  },
  text: {
    textAlign: 'center',
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
  },
});
